export interface RatioPreset {
  id: string;
  a: number;
  b: number;
}

export const RATIO_PRESETS: readonly RatioPreset[] = [
  { id: 'one-to-one', a: 1, b: 1 },
  { id: 'two-to-three', a: 2, b: 3 },
  { id: 'golden', a: 1000, b: 1618 },
];
